export const getAssetDimensionNameByLocale = (translations, locale) => {
  const name = translations.find(trx => trx?.locale === locale)
  return name ? name.text : ''
}
